import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLink = "text-gray-500 hover:text-white transition-colors text-sm";

  return (
    <footer className="bg-surface border-t border-gray-700/20 pt-12 pb-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <img src="/assets/icon-new.png" alt="SunServ Logo" className="w-7 h-7" />
              <span className="text-lg font-bold text-white" style={{ fontFamily: 'var(--font-display)' }}>
                Sun<span className="text-yellow-400">Serv</span>
              </span>
            </div>
            <p className="text-xs text-gray-500 leading-relaxed mb-4">
              Hébergement gaming professionnel depuis 2021.
            </p>
            <div className="flex gap-3">
              <a href="https://discord.com/invite/WEJGaTeDCy" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-yellow-400 transition-colors">
                <i className="fab fa-discord text-lg"></i>
              </a>
              <a href="https://twitter.com/sunservxyz" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-yellow-400 transition-colors">
                <i className="fab fa-twitter text-lg"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Services</h4>
            <ul className="space-y-2">
              <li><a href="https://sunserv.fr/shop" className={footerLink}>Serveurs de jeu</a></li>
              <li><a href="https://sunserv.fr/shop/vps" className={footerLink}>VPS</a></li>
              <li><Link to="/" className={footerLink}>Blog</Link></li>
            </ul>
          </div>

          {/* Community */}
          <div>
            <h4 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Communauté</h4>
            <ul className="space-y-2">
              <li><Link to="/contributors" className={footerLink}>Contributeurs</Link></li>
              <li><a href="https://sunserv.fr/partenaires" className={footerLink}>Partenaires</a></li>
              <li><a href="https://discord.com/invite/WEJGaTeDCy" target="_blank" rel="noopener noreferrer" className={footerLink}>Discord</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Support</h4>
            <ul className="space-y-2">
              <li><a href="https://sunserv.fr/about" className={footerLink}>À propos</a></li>
              <li><a href="https://sunserv.fr/cgu" className={footerLink}>CGU</a></li>
              <li><a href="https://sunserv.fr/partenariat" className={footerLink}>Devenir partenaire</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700/20 pt-5 text-center">
          <p className="text-xs text-gray-600">
            &copy; 2021-{currentYear} SunServ — Cumulus Corporation
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
